import React, { useEffect, useState } from 'react';
import { Icon } from './inboxIcons';
import { reportProblem } from './ProblemReport';

// Your reports: what you flagged with "Report a problem", its status and the reply. Opening the page marks replies seen.
const TONE = { open: 'cx-c-plain', working: 'cx-c-waiting', fixed: 'cx-c-resolved', cant_fix: 'cx-c-plain', not_problem: 'cx-c-plain' };
const when = (ms) => (ms ? new Date(ms).toLocaleString('en-IN', { day: 'numeric', month: 'short', hour: 'numeric', minute: '2-digit' }) : '');

function MyReportsPage({ api, onSeen, onOpenTicket }) {
  const [d, setD] = useState(null);
  const [err, setErr] = useState(null);
  const [tick, setTick] = useState(0);
  useEffect(() => {
    const again = () => setTick((t) => t + 1);
    window.addEventListener('cx-reported', again);
    return () => window.removeEventListener('cx-reported', again);
  }, []);
  useEffect(() => {
    let alive = true;
    api('/api/v1/support/problems/mine').then((r) => {
      if (!alive) return;
      setD(r);
      if (r.unseen) api('/api/v1/support/problems/mine/seen', 'POST', {}).then(() => onSeen?.()).catch(() => {});
    }).catch((e) => alive && setErr(e.message));
    return () => { alive = false; };
  }, [api, onSeen, tick]);

  return (
    <div className="cx-page">
      <div className="cx-page-in">
        <div className="cx-page-head">
          <div>
            <h1>Your reports</h1>
            <p className="cx-lede">Problems you reported with "Report a problem" in a chat, and what came of them.</p>
          </div>
          <div className="cx-page-actions"><button className="cx-btn" onClick={() => reportProblem({ where: 'chat' })}><Icon name="flag" />Report something</button></div>
        </div>
        {err ? <div className="cx-empty"><strong>Couldn't load your reports</strong>{err}</div>
          : !d ? <div className="cx-skel" style={{ height: 200 }} />
            : !d.problems.length ? <div className="cx-empty"><strong>No reports yet</strong>Spot something wrong in a chat? Use the flag on a message, the order card, or "Report a problem" at the top of the chat.</div>
              : (
                <div className="cx-prob-list">
                  {d.problems.map((p) => (
                    <div key={p.id} className={`cx-prob${p.news ? ' news' : ''}`}>
                      <div className="cx-prob-h">
                        <span className={`cx-chip ${TONE[p.status] || 'cx-c-plain'}`}>{p.atOrderDesk && (p.status === 'open' || p.status === 'working') ? 'At Order Desk' : d.statusLabel[p.status] || p.status}</span>
                        <b>{p.typeLabel}</b>
                        <span className="cx-hint">{p.customerName ? `${p.customerName} · ` : ''}{when(p.createdAtMs)}</span>
                        {p.ticketId && onOpenTicket && <button className="cx-linkbtn" onClick={() => onOpenTicket(p.ticketId)}>Open chat</button>}
                      </div>
                      {p.truth && <div className="cx-hint">You wrote: {p.truth}</div>}
                      {p.closeNote && <div className="cx-prob-reply"><Icon name="chat" size={14} />{p.closeNote}{p.closedBy ? ` · ${p.closedBy}` : ''}{p.closedAtMs ? `, ${when(p.closedAtMs)}` : ''}</div>}
                    </div>
                  ))}
                </div>
              )}
      </div>
    </div>
  );
}

export default MyReportsPage;
